module.exports = __webpack_public_path__ + "images/backgrounds/mountain/full.171b0c9aea08e21f0020.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/mountain/full.jpg
// module id = BfvL
// module chunks = 0